export const Actions = {
  UserInfo: 'getUserInfo',
  LogoutUser: 'logoutUser',
  LoginUser: 'loginUser',
  SendInvite: 'sendInvite',
  SendResetEmail: 'sendResetEmail',
  Firebase: {
    UploadImage: 'uploadImage',
    UploadPrivateDocuments: 'uploadPrivateDocuments',
    UpdateUserInfo: 'updateUserInfo',
    Reset: 'fbResetPW',
    UserInfo: 'getUserInfo'
  },

  Countries: 'countries',
  CompanyInfo: 'companyInfo',
  Dashboard: 'dashboard',
  CompanyUpdate: 'companyUpdate',
  CompanyAddMembership: 'companyAddMembership',
  CompanyTimeline: 'companyTimeline',
  Company: {
    Info: 'companyInfo',
    Company: "company",
    MembershipInfo: 'companyMembershipInfo',
    BillingSession: "companyStartBillingSession",
    MembershipSessionCancelled: "companyMembershipSessionCancelled",

  },

  Activate: 'authActivate',
  Auth: {
    Status: 'authStatus',
    ResetPassword: 'authResetPassword',
    UserByCode: 'authUserByCode',
    ActivateEmp: 'authActivateEmp',
    AccessRequestList: 'accessRequestList',
    AddAccessRequest: 'addAccessRequest'
  },
  SendEmail: 'sendAuthEmail',
  Calendar: {
    Info: 'calendarInfo',
    Sync: 'calendarSync',
    UnSync: 'calendarUnSync',
    Search: 'calendarSearch',
    Preview: 'calendarPreview',
    UpdateEntry: 'calendarUpdateEntry',
    DeleteEntry: 'calendarDeleteEntry',
    AddEntry: 'calendarAddEntry',
  },
  LocationFind: 'locationFind',
  LocationAdd: 'locationAdd',
  LocationDelete: 'locationDelete',
  LocationEdit: 'locationEdit',
  LocationGet: 'locationGet',
  DepartmentAdd: 'departmentAdd',
  DepartmentDelete: 'departmentDelete',
  DepartmentEdit: 'departmentEdit',
  DepartmentGet: 'departmentGet',
  DepartmentFind: 'departmentFind',
  Workflow: {
    Create: 'workflowCreate',
    Get: 'workflowGet',
    Delete: 'workflowDelete',
    Find: 'workflowFind',
    Edit: 'workflowEdit',
    GetWorkflowToDos: 'workFlowToDos'
  },
  Backoffice: {
    Add: 'backofficeAdd',
    Get: 'backofficeGet',
    Delete: 'backofficeDelete',
    Find: 'backofficeFind',
    Edit: 'backofficeEdit',
  },
  LeaveTypes: {
    Find: 'leaveTypesFind',
    Admin: 'leaveTypesAdmin',
    Add: 'leaveTypesAdd',
    Delete: 'leaveTypesDelete',
    Edit: 'leaveTypesEdit',
    Get: 'leaveTypesGet',
  },
  MarketPlaceOffers: {
    Find: 'marketplaceOfferFind',
    SaveSearch: 'saveSearch',
    GetSearch: 'getSearch',
    Info: 'marketplaceInfo'
  },
  Benefits: {
    Find: 'findBenefits',
    Get: 'getBenefit',
    Delete: 'deleteBenefit',
    Edit: 'editBenefit',
    Add: 'addBenefit',
    GetProviderInfo: 'providerInfo',
    GetProviderInfoByID: 'providerInfoByID',
    AddProviderInfo: 'addProviderInfo',
    GetProviderBenefits: 'getProviderBenefits',
    AddProviderBenefits: 'addProviderBenefits',
    EditProviderBenefits: 'editProviderBenefits',
    DeleteProviderBenefits: 'deleteProviderBenefits',
    ProductDetails: 'productDetails',
    ActivateOffer: 'activateOffer',
    Recommendations: 'providerRecommendation',
    AddRecommendation: 'addProviderRecommendation',
    EditRecommendation: 'editProviderRecommendation',
    GetRecommendation: 'getProviderRecommendation',
    UpvoteOffer: 'upvoteOffer'
  },
  TimeOff: {
    Find: 'findTimeOffs',
    Delete: 'deleteTimeOff',
    Add: 'addTimeOff',
    Edit: 'editTimeOff',
    GetByIdAndAggregation: 'getTimeOffByIdAndAggregation',
    Get: 'getTimeOff',
    Info: 'infoTimeOff',
    Rollback: 'rollbackTimeoff',
    Aggregate: 'aggregateTimeoff',
  },

  Employee: {
    Me: 'employeeMe',
    Get: 'employeeGet',
    Find: 'employeeFind',
    Address: 'employeeAddress',
    Info: 'employeeInfo',
    AddressSave: 'employeeAddressSave',
    Save: 'employeeSave',
    Add: 'employeeAdd',
    Delete: 'employeeDelete',
    Timeline: 'employeeTimeline',
    AddToTimeline: 'employeeAddToTimeline',
    OffBoarding: 'employeeOffBoarding',
    Profile: 'employeeProfile',
    MePersonal: 'employeeMePersonal',
    MePersonalUpdate: 'employeeMePersonalUpdate',
    Personal: 'employeePersonal',
    UpdatePersonal: 'employeePersonalUpdate'
  },
  Document: {
    Save: 'documentSave',
    Get: 'documentGet',
    All: 'documentAll',
  },
  Announcement: {
    Find: 'announcementFind',
    Delete: 'announcementDelete',
    Edit: 'announcementEdit',
    Get: 'announcementGet',
    Add: 'announcementAdd',
  },
  Tasks: {
    Find: 'tasksFind',
    Complete: 'tasksComplete',
  },
  Timeline: {
    Get: 'timelineGet',
    Put: 'timelinePut',
    Delete: 'timelineDelete',
  },
  Membership: {
  }

};